  /* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

require("@rails/ujs").start()
require("@rails/activestorage").start()
import 'es6-promise/auto'
import Vue from 'vue';

// Import the EventBus.
import EventBus from '../utils/event-bus.js';

import Flickity from 'vue-flickity';


import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter,
  {
    symbol : '£',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
  })

import { ValidationProvider, extend } from 'vee-validate';
import { required, email, min} from 'vee-validate/dist/rules';
extend('email', {
  ...email,
  message: 'Please enter a valid email address'
});
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('min', {
  ...min,
  message: 'Please enter a valid number'
});
Vue.component('ValidationProvider', ValidationProvider)

import Modal from '../components/modal.vue'
import Products from '../components/products.vue'
import ContactForm from '../components/contact-form.vue'
import TradeForm from '../components/trade-form.vue'
import ArticlesGrid from '../components/articles-grid.vue'
import ShoppingCart from '../components/shopping-cart.vue'
import Checkout from '../components/checkout.vue'
import FrequentlyAskedQuestion from '../components/faq.vue'
import PlayButton from '../components/play-button.vue'
import VideoModal from '../components/video-modal.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '[data-behavior="vue"]',
    components: {
      Modal,
      Products,
      ContactForm,
      TradeForm,
      ArticlesGrid,
      ShoppingCart,
      Flickity,
      Checkout,
      FrequentlyAskedQuestion,
      PlayButton,
      VideoModal,
    }
  })

  // Mobile Nav

  const header = document.querySelector('header');
  const body = document.querySelector('body');
  const navToggle = document.querySelector('.nav-toggle');
  const navToggleIcon = document.querySelector('.nav-toggle-icon');
  const nav = document.querySelector('.mobile-nav');

  if (navToggle) {
    navToggle.addEventListener('click', function() {
      let headerHeight = header.clientHeight;
      let navHeight = nav.scrollHeight;
      let screenHeight = window.innerHeight;

      if(!navToggleIcon.classList.contains('is-active') && window.innerWidth < 769) {
        navToggleIcon.classList.add('is-active');
        nav.style.maxHeight = (screenHeight - headerHeight) + 'px';
        body.classList.add('no-scroll');
      } else {
        navToggleIcon.classList.remove('is-active');
        body.classList.remove('no-scroll');
        nav.style.maxHeight = 0;
      }
    });
  }


  // Video modal on homepage

  const playButton = document.querySelector('#play-button');

  if(playButton) {
    playButton.addEventListener('click', () => {
      body.classList.add('video-modal-visible');
    });
  }

  // Listen for the i-got-clicked event and its payload.
  EventBus.$on('video-modal-closed', () => {
    if(body.classList.contains('video-modal-visible')) {
      body.classList.remove('video-modal-visible');
    }
  });

  
  
  // Scroll-based styling changes in mobile header 

  // Scrollstop detection

   /*!
  * Run a callback function after scrolling has stopped
  * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
  * @param  {Function} callback The function to run after scrolling
  */
  var scrollStop = function (callback) {

    // Make sure a valid callback was provided
    if (!callback || typeof callback !== 'function') return;

    // Setup scrolling variable
    var isScrolling;

    // Listen for scroll events
    window.addEventListener('scroll', function (event) {

      // Clear our timeout throughout the scroll
      window.clearTimeout(isScrolling);

      // Set a timeout to run after scrolling ends
      isScrolling = setTimeout(function() {

        // Run the callback
        callback();

      }, 66);
    }, false);
  };

  // Initial state
  var scrollPos = 0;
  // adding scroll event
  window.addEventListener('scroll', function(){
    if(scrollPos <= 0) {
      // detects new state and compares it with the new one
      if ((document.body.getBoundingClientRect()).top < scrollPos) {
        document.body.classList.add('header-compact');
      } else {
        document.body.classList.remove('header-compact');
      }
    }
    // saves the new position for iteration.
    scrollPos = (document.body.getBoundingClientRect()).top;
  });

  scrollStop(function () {
    if ((document.body.getBoundingClientRect()).top == 0) {
      if(document.body.classList.contains('header-compact')) {
        document.body.classList.remove('header-compact');
      }
    }
  });
});

